import { useAuth } from 'lib/context';
import { useCDK } from 'lib/hooks/useCdk';
import { isAdminSession } from 'lib/utils/auth';
import { isEnvProduction } from 'configs/api/enviroments';

export const useShouldBypassIntercom = (): boolean => {
  const { userData, whitelabel } = useAuth();
  const { isCdkUser } = useCDK();

  return (
    !whitelabel?.intercomId ||
    !userData?.intercom?.app_id ||
    !isEnvProduction ||
    isAdminSession() ||
    isCdkUser
  );
};
